import { BoxPlotOutlined, CalendarOutlined, CheckSquareOutlined, DatabaseOutlined, ExperimentOutlined, PercentageOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { RubleIcon } from '../components/common';
import type { StageConfig } from './types';

export const REFERENCE_MODULES: StageConfig[] = [
  {
    title: '',
    description: 'Ключевой ассортимент',
    icon: <DatabaseOutlined />,
    path: 'assortment',
    rbacResource: 'references_assortment',
  },
  {
    title: '',
    description: 'Планирование цен',
    icon: <RubleIcon />,
    path: 'pricing',
    rbacResource: 'references_pricing',
    views: [
      { key: 'pack', label: 'Упаковки', icon: <BoxPlotOutlined /> },
      { key: 'gram', label: 'Граммы', icon: <ExperimentOutlined /> },
    ],
  },
  {
    title: '',
    description: 'Корректировка цен',
    icon: <RubleIcon />,
    path: 'price-correction',
    rbacResource: 'references_pricing',
    configSection: 'references_correction',
  },
  {
    title: '',
    description: '% распределения планов по периодам',
    icon: <PercentageOutlined />,
    path: 'shipment',
    rbacResource: 'references_shipment',
  },
  {
    title: '',
    description: 'Поставщики-КНП',
    icon: <TeamOutlined />,
    path: 'suppliers',
    rbacResource: 'references_suppliers',
  },
  {
    title: '',
    description: 'Управление клиентами',
    icon: <UserOutlined />,
    path: 'clients',
    rbacResource: 'references_clients',
  },
  {
    title: '',
    description: 'Дата старта динамического планирования',
    icon: <CalendarOutlined />,
    path: 'approval-date',
    rbacResource: 'references_approval',
  },
  {
    title: '',
    description: 'Актуализация динамического плана',
    icon: <CheckSquareOutlined />,
    path: 'actualization',
    rbacResource: 'references_actualization',
  },
];
